import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  pb: [80, 80, 100, 100, 120],
  px: LANDING_INLINE_PADDINGS,
})`
  width: 100%;
  justify-content: center;
  position: relative;
`

export const Content = styled(Flex).attrs({
  pt: [56, 56, 72, 72, 88],
  pb: [64, 64, 80, 80, 100],
  px: [24, 24, 70, 70, 200],
})`
  flex-direction: column;
  border-radius: 20px;
  width: 100%;
  background-color: ${themeGet('colors.almondLight')};
  z-index: 1;
`

export const DotsWrapper = styled(Flex).attrs({
  display: ['none', 'none', 'none', 'flex'],
})`
  position: absolute;
  bottom: -33px;
  left: -33px;
  z-index: 0;
`
